<template>
    <div class="bd">
        <div class="my-custom-table">
            <a-page-header title="追问管理" />
            <div class="search-bar">
                <div class="tabInput">
                    <a>问题关键词：</a>
                    <a-input v-model:value="queryKeyword" placeholder="请输入问题关键词进行搜索" class="search-input" />
                </div>
                <div class="tabInput">
                    <a>案例编号：</a>
                    <a-input v-model:value="queryCaseNo" placeholder="请输入案例编号进行搜索" class="search-input" />
                </div>
                <div class="tab-button">
                    <div>
                        <a-button class="search-tow" type="primary" @click="onSearch" :icon="h(SearchOutlined)">搜索</a-button>
                        <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                    </div>
                    <div class="right-option">
                        <a-button type="primary" @click="toExport" :icon="h(DownloadOutlined)" ghost>导出</a-button>
                        <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                        <addFollowComponent ref="childOpen" />
                        <editFollowComponent ref="childEdit" />
                        <exportFollowComponent ref="childExport" />
                    </div>
                </div>
            </div>
            <a-table :columns="columns" :data-source="data" :pagination="false" row-key="id">
                <template #bodyCell="{ column, text, record }">
                    <template v-if="column.key === 'keyword' || column.key === 'followContent'">
                        <a-tooltip :title="text">
                            <span v-if="column.key === 'keyword'" style="cursor: pointer; color: #1890ff;" @click="copyText(text)">{{ text && text.length > 15 ? text.slice(0, 15) + '...' : text }}</span>
                            <span v-else>{{ text && text.length > 15 ? text.slice(0, 15) + '...' : text }}</span>
                        </a-tooltip>
                    </template>
                    <template v-if="column.key === 'caseNo'">
                        <a-tag color="blue">{{ text }}</a-tag>
                    </template>
                    <template v-if="column.key === 'parentId'">
                        <a-tag v-if="!text" color="green">主追问</a-tag>
                        <a-tag v-else color="orange">子追问</a-tag>
                    </template>
                    <template v-if="column.key === 'status'">
                        <a-tag v-if="text === '正常'" color="green">{{ text }}</a-tag>
                        <a-tag v-else color="red">{{ text }}</a-tag>
                    </template>
                    <template v-if="column.dataIndex === 'operation'">
                        <a @click="edit(record)">查看</a>
                        <template v-if="!record.parentId">
                            <a-divider type="vertical" />
                            <a @click="addChild(record)">添加追问</a>
                        </template>
                        <a-divider type="vertical" />
                        <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                            <a style="margin: 15px;">删除</a>
                        </a-popconfirm>
                    </template>
                </template>
            </a-table>
            <div style="display: flex; justify-content: flex-end; margin-top: 16px;">
                <a-pagination
                    :current="pagination.current"
                    :total="pagination.total"
                    :page-size="pagination.pageSize"
                    show-size-changer
                    show-quick-jumper
                    :show-total="(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`"
                    @change="handlePaginationChange"
                    @show-size-change="handleSizeChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { followQuestionPage, removeFollowQuestion } from '@/api/service';
import { cloneDeep } from 'lodash-es';
import { SearchOutlined, RedoOutlined, PlusCircleOutlined, DownloadOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { ref, h } from 'vue';
import addFollowComponent from './modal/addComponent.vue';
import editFollowComponent from './modal/editComponent.vue';
import exportFollowComponent from './modal/exportComponent.vue';

export default {
    name: 'FollowQuestionPage',
    components: {
        addFollowComponent,
        editFollowComponent,
        exportFollowComponent,
    },
    setup() {
        const data = ref([]);
        const queryKeyword = ref('');
        const queryCaseNo = ref('');
        const childOpen = ref(null);
        const childEdit = ref(null);
        const childExport = ref(null);
        const pagination = ref({
            current: 1,
            pageSize: 5,
            total: 0,
            showSizeChanger: true,
            showQuickJumper: true
        });

        const columns = [
            { title: '问题关键词', dataIndex: 'keyword', key: 'keyword', width: '12%' },
            { title: '追问轮次', dataIndex: 'followRound', key: 'followRound', width: '6%' },
            { title: '追问类型', dataIndex: 'parentId', key: 'parentId', width: '6%' },
            { title: '追问内容', dataIndex: 'followContent', key: 'followContent', width: '12%' },
            { title: '关联案例', dataIndex: 'caseNo', key: 'caseNo', width: '10%' },
            { title: '状态', dataIndex: 'status', key: 'status', width: '5%' },
            { title: '追问人', dataIndex: 'createBy', key: 'createBy', width: '8%' },
            { title: '追问时间', dataIndex: 'createdAt', key: 'createdAt', width: '8%' },
            { title: '操作', dataIndex: 'operation', key: 'operation', width: '10%' },
        ];

        const list = async () => {
            const response = await followQuestionPage({
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
                keyword: queryKeyword.value,
                caseNo: queryCaseNo.value
            });
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data.totalRow || response.data.total || 0;
                data.value = (response.data.records || []).map(item => ({
                    id: item.id,
                    caseNo: item.caseNo,
                    keyword: item.keyword,
                    followRound: item.followRound,
                    followContent: item.followContent,
                    status: item.status,
                    createBy: item.createBy,
                    createdAt: item.createdAt,
                    parentId: item.parentId,
                }));
            }
        };

        list();

        const handlePaginationChange = (page, pageSize) => {
            pagination.value.current = page;
            pagination.value.pageSize = pageSize;
            list();
        };

        const handleSizeChange = (current, size) => {
            pagination.value.current = 1;
            pagination.value.pageSize = size;
            list();
        };

        const deleteFollowQuestion = async (id) => {
            const response = await removeFollowQuestion(id);
            if (response.code === 200) {
                message.success('删除成功');
                return true;
            } else {
                message.error('删除失败' + response.msg);
                return false;
            }
        };

        const remove = async (id) => {
            const success = await deleteFollowQuestion(id);
            if (success) {
                data.value = cloneDeep(data.value.filter(item => id != item.id));
            }
        };

        const edit = (record) => {
            childEdit.value.openEdit(record);
        };

        const addChild = (record) => {
            childOpen.value.openForChild(record.id);
        };

        const copyText = (text) => {
            navigator.clipboard.writeText(text).then(() => {
                message.success('已复制');
            }).catch(() => {
                message.error('复制失败');
            });
        };

        const onSearch = () => {
            pagination.value.current = 1;
            list();
        };

        const onReset = () => {
            queryKeyword.value = '';
            queryCaseNo.value = '';
            list();
        };

        const toAdd = () => {
            childOpen.value.open = true;
        };

        const toExport = () => {
            childExport.value.openExport();
        };

        return {
            columns,
            pagination,
            data,
            queryKeyword,
            queryCaseNo,
            childOpen,
            childEdit,
            childExport,
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            DownloadOutlined,
            onSearch,
            onReset,
            toAdd,
            toExport,
            h,
            ref,
            remove,
            edit,
            addChild,
            copyText,
            handlePaginationChange,
            handleSizeChange,
            list,
        };
    },
};
</script>
<style></style>
